import {
	GET_SSID_LIST,
	GET_SSID_LIST_SUCCESS,
	GET_SSID_LIST_FAIL,
	OPEN_GLOBAL_SSID_MODAL,
	ADD_SSID,
	ADD_SSID_COMPLETE,
	EDIT_SSID,
	EDIT_SSID_COMPLETE,
	SSID_ADD_TRIGGER,
	DELETE_SSID_SUCCESS,
	DELETE_SSID_FAIL,
	RESET_GLOBAL_SSID,
	SHOW_SSID_MODAL,
} from '../constants/ssid/ssidConstants';

/**
 * Reducer function for managing ssid list state.
 *
 * This reducer handles actions related to fetching ssid data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the ssid list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const SSIDReducer = (
	state = {
		ssidList: {},
		editGlobalSSID: false,
		editRow: false,
		addSSIDData: {},
		editGlobalSSIDData: {},
		deleteGlobalSSIDSuccess: null,
		deleteGlobalSSIDFail: null,
	},
	action
) => {
	switch (action.type) {
		case GET_SSID_LIST:
			return {
				...state,
				loading: true,
			};
		case GET_SSID_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				ssidList: action.payload,
			};
		case GET_SSID_LIST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case OPEN_GLOBAL_SSID_MODAL:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case ADD_SSID:
			return {
				...state,
				// loading: true,
			};
		case EDIT_SSID:
			return {
				...state,
				// loading: true,
			};
		case ADD_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				addSSIDData: action.payload,
			};
		case EDIT_SSID_COMPLETE:
			return {
				...state,
				loading: false,
				editGlobalSSIDData: action.payload,
			};
		case DELETE_SSID_SUCCESS: {
			return {
				...state,
				deleteGlobalSSIDSuccess: action.payload,
			};
		}
		case DELETE_SSID_FAIL: {
			return {
				...state,
				deleteGlobalSSIDFail: action.payload,
			};
		}
		case RESET_GLOBAL_SSID:
			return {
				...state,
				editGlobalSSID: false,
				addSSIDData: null,
				editSSIDData: {},
				editRow: null,
				deleteGlobalSSIDSuccess: null,
				deleteGlobalSSIDFail: null,
				editGlobalSSIDData: null,
			};
		default:
			return state;
	}
};
export const ssidTriggerReducer = (
	state = { ssidAddTrigger: false },
	action
) => {
	switch (action.type) {
		case SSID_ADD_TRIGGER:
			return {
				...state,
				ssidAddTrigger: action.payload,
			};
		case SHOW_SSID_MODAL:
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};
